// extracted by mini-css-extract-plugin
export default {"wrap":"App_wrap__GzNCU","header":"App_header__fhC8n","headerLogo":"App_headerLogo__wBoOD","appBody":"App_appBody__wkvg7","returnLink":"App_returnLink__SDwED"};